// ProductType Vuex

import state from './inventoryStates.js'
import * as getters from './inventoryGetters.js'
import * as mutations from './inventoryMutations.js'
import * as actions from './inventoryActions.js'

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
